import React, { useState } from 'react';
import { HelpCircle, ChevronDown } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqItems = [
    {
      question: 'Was ist IDA?',
      answer: 'IDA ist eine intuitive Compliance-App für Wettbüros und Spielhallen, die dabei hilft, gesetzliche Anforderungen zu erfüllen.'
    },
    {
      question: 'Ist IDA DSGVO-konform?',
      answer: 'Ja, IDA erfüllt alle DSGVO-Anforderungen und gewährleistet höchste Datenschutzstandards.'
    },
    {
      question: 'Kann IDA angepasst werden?',
      answer: 'Ja, IDA kann an Ihre spezifischen Anforderungen und Prozesse angepasst werden.'
    },
    {
      question: 'Welche Geräte unterstützt IDA?',
      answer: 'IDA läuft als Web-Applikation und ist auf Tablets, Smartphones und PCs nutzbar.'
    },
    {
      question: 'Was ist das IDA Zeiterfassungsmodul?',
      answer: 'Das Zeiterfassungsmodul erweitert IDA um Funktionen zur Zeiterfassung, Projektverfolgung, Urlaubs-/Abwesenheitsverwaltung und mobile Zeiterfassung. Es unterstützt bis zu 10 Mitarbeiter und kann als Add-on zu jedem IDA-Abo hinzugefügt werden.'
    },
    {
      question: 'Warum ist die Kombination von Checklisten und Zeiterfassung so effektiv?',
      answer: 'Die Integration von Compliance-Checklisten und Zeiterfassung ist IDA\'s Killerfeature: Mitarbeiter können ihre Arbeitszeit erst dann erfassen, wenn sie die obligatorischen Checklisten ausgefüllt haben - bei Schichtbeginn UND Schichtende. Ohne ausgefüllte Checklisten: keine Zeiterfassung, keine Lohnabrechnung. Dies schafft eine Win-Win-Situation für beide Seiten: Betreiber erhalten 100% Compliance-Sicherheit ohne Mikromanagement, Mitarbeiter profitieren von fairer, nachvollziehbarer Zeiterfassung. Das System verhindert das häufigste Problem in Spielhallen: vergessene Spielerschutz-Kontrollen am Schichtende. Resultat: Bis zu 95% weniger Compliance-Verstöße.'
    }
  ];

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-xl text-gray-700 max-w-3xl mx-auto">
            Alles, was Sie über IDA wissen müssen
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-teal-700 to-blue-500 mx-auto rounded-full mt-6"></div>
        </div>

        {/* FAQ Accordion Items */}
        <div className="space-y-4">
          {faqItems.map((item, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className={`bg-white rounded-2xl border-2 transition-all duration-300 ${
                  isOpen
                    ? 'border-teal-700 shadow-lg bg-gradient-to-br from-teal-50/30 via-white to-white'
                    : 'border-gray-200 hover:border-teal-700 hover:shadow-md hover:-translate-y-0.5'
                }`}
              >
                {/* Question Bar - Clickable */}
                <button
                  onClick={() => toggleItem(index)}
                  className="w-full px-6 py-5 flex items-center gap-4 text-left cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 focus-visible:ring-offset-2 rounded-2xl"
                  aria-expanded={isOpen}
                  aria-controls={`faq-answer-${index}`}
                  id={`faq-question-${index}`}
                >
                  {/* Question Icon */}
                  <HelpCircle
                    className={`w-6 h-6 flex-shrink-0 transition-colors duration-300 ${
                      isOpen ? 'text-teal-700' : 'text-teal-700'
                    }`}
                  />

                  {/* Question Text */}
                  <span className="flex-grow text-lg font-semibold text-gray-900">
                    {item.question}
                  </span>

                  {/* Chevron Icon */}
                  <ChevronDown
                    className={`w-6 h-6 flex-shrink-0 transition-all duration-300 ${
                      isOpen
                        ? 'text-teal-700 rotate-180'
                        : 'text-gray-400 group-hover:text-gray-600'
                    }`}
                  />
                </button>

                {/* Answer Area - Expandable */}
                <div
                  id={`faq-answer-${index}`}
                  role="region"
                  aria-labelledby={`faq-question-${index}`}
                  className={`overflow-hidden transition-all duration-300 ease-out ${
                    isOpen ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-6 pb-6 pt-4">
                    <p className="text-base text-gray-700 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
